import { MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltipDefaultOptions } from '@angular/material/tooltip';

/**
 * A `matTooltip` stays open while the pointer is over it, and its panel lives in the CDK overlay
 * container rather than inside the scroll area it belongs to, so the wheel over it scrolls nothing
 * — a board column froze whenever the pointer drifted from an address into its tooltip. A
 * non-interactive tooltip lets pointer events through to whatever is underneath, and closes once
 * the pointer leaves its trigger. On a touch platform a trigger would set `touch-action: none` on
 * itself, so a swipe that starts on it couldn't scroll a board or list — touch gestures are off and
 * touch screens show no `matTooltip`. Providing the token replaces Material's defaults rather than
 * merging with them, so the delays are restated.
 */
export const provideTooltipDefaults = () => ({
  provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
  useValue: {
    showDelay: 0,
    hideDelay: 0,
    touchendHideDelay: 1500,
    disableTooltipInteractivity: true,
    touchGestures: 'off',
  } satisfies MatTooltipDefaultOptions,
});
